/** @format */

import React, { Component } from 'react';
import { Modal, Header, Icon, Form } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';

@inject('RequestsStore')
@observer
class HasBeenPrintedModal extends Component {
  render() {
    const { RequestsStore } = this.props;
    return (
      <Modal open={RequestsStore.requestsParams.hasBeenPrintedModal.active}>
        <Modal.Content>
          <Header className="modal-header alert" as="h3">
            <small>
              <Icon name="print" />
            </small>{' '}
            Documento già stampato
          </Header>
          <div className="header-spacer"></div>
          Attenzione, il documento è stato già stampato. Si intende ugualmente
          procedere con la stampa?
          <br />
          <br />
          <Form>
            <Form.Group widths="equal" className="no-margin-bottom">
              <Form.Button
                type="button"
                fluid
                color="red"
                icon="cancel"
                onClick={() => RequestsStore.closeHasBeenPrintedModal()}
              >
                Non Stampare
              </Form.Button>
              <Form.Button
                type="button"
                fluid
                color="green"
                icon="check"
                onClick={() => {
                  RequestsStore.printRequest();
                  RequestsStore.closeHasBeenPrintedModal();
                }}
              >
                Stampa
              </Form.Button>
            </Form.Group>
          </Form>
          <div
            className="close-button"
            onClick={() => {
              RequestsStore.closeHasBeenPrintedModal();
            }}
          >
            X
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}

export default HasBeenPrintedModal;
